import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { BarChart } from '@mui/x-charts/BarChart';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

function getRiskColorById(theme) {
  return {
    low: (theme.vars || theme).palette.warning.main,
    medium: theme.palette.mode === 'light' ? '#FB8C00' : '#FFB74D',
    high: (theme.vars || theme).palette.error.main,
  };
}

function RiskQuantityChart({ title, description, variation, value, labels, transactions }) {
  const theme = useTheme();
  const riskColorById = getRiskColorById(theme);
  const colorPalette = transactions.map(
    (transaction) => riskColorById[transaction.id] || (theme.vars || theme).palette.warning.main,
  );

  return (
    <Card variant="outlined" sx={{ width: '100%' }}>
      <CardContent>
        <Typography component="h2" variant="subtitle2" gutterBottom>
          {title}
        </Typography>
        <Stack sx={{ justifyContent: 'space-between' }}>
          <Stack
            direction="row"
            sx={{
              alignContent: { xs: 'center', sm: 'flex-start' },
              alignItems: 'center',
              gap: 1,
            }}
          >
            <Typography variant="h4" component="p">
              {value}
            </Typography>
            <Chip size="small" color="error" label={variation} />
          </Stack>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            {description}
          </Typography>
        </Stack>
        <BarChart
          borderRadius={8}
          colors={colorPalette}
          xAxis={[
            {
              scaleType: 'band',
              categoryGapRatio: 0.5,
              data: labels,
              height: 24,
            },
          ]}
          yAxis={[{ width: 50 }]}
          series={transactions.map((transaction, index) => (
            {
              id: transaction.id,
              label: transaction.label,
              data: transaction.quantity,
              stack: 'A',
            }
          ))}
          height={250}
          margin={{ left: 0, right: 0, top: 20, bottom: 0 }}
          grid={{ horizontal: true }}
          sx={{
            '& .MuiBarElement-root': {
              fillOpacity: 0.5,
            },
          }}
          // hideLegend
        />
      </CardContent>
    </Card>
  );
}

RiskQuantityChart.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  transactions: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default RiskQuantityChart;
